<!--
 * @Description:
 * @Author: Mankeung
 * @Date: 2021-07-07 10:03:48
 * @LastEditors: Mankeung
 * @LastEditTime: 2021-07-21 18:55:32
-->
<template>
  <section>
    <div class="role">
      <div class="roleRight" style="border-left: 0">
        <div class="roleRight_Top">
          <el-input
              v-if="searchShow"
              clearable
              v-model="search.searchKey"
              clas="input_search"
              placeholder="搜索关键字"
              @keyup.enter.native="SearchPostList"
          ></el-input>
          <el-select v-if="searchShow" v-model="search.verStatus" clearable placeholder="请选择">
            <el-option label="计划版本" value="3"></el-option>
            <el-option label="发布失败" value="2"></el-option>
            <el-option label="已发布" value="1"></el-option>
            <el-option label="待发布" value="0"></el-option>
          </el-select>
          <el-button v-if="searchShow" size="medium" type="primary" @click="SearchPostList"
          >查询
          </el-button
          >
          <el-button
              v-if="addShow"
              size="medium"
              type="primary"
              @click="handleClick('addNext')"
          >新增
          </el-button
          >
        </div>
        <div class="roleRight_Container public-table-data">
          <el-table v-loading="loading" :data="tableData" size="medium" border>
            <el-table-column
                fixed
                label="序号"
                prop="postId"
                type="index"
                width="100"
            >
              <template slot-scope="scope">
                <span>{{
                    (page.pageNo - 1) * page.pageSize + scope.$index + 1
                  }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="verid" label="版本号" min-width="50">
            </el-table-column>
            <el-table-column prop="verStatusName" label="状态" align="center" width="100">
            </el-table-column>
            <el-table-column prop="verTime" label="发布时间" min-width="50">
            </el-table-column>
            <el-table-column prop="title" label="标题" min-width="50">
            </el-table-column>
            <el-table-column prop="createInfoName" label="发布人" min-width="50">
            </el-table-column>
            <el-table-column prop="ctime" label="创建时间" min-width="50">
            </el-table-column>
            <el-table-column v-if="editShow || deleteShow" fixed="right" label="操作">
              <template slot-scope="scope">
                <el-button
                    v-if="editShow"
                    @click="handleClick('change', scope.row)"
                    plain
                    size="small"
                >修改
                </el-button
                >
                <el-button
                    v-if="deleteShow"
                    type="primary"
                    plain
                    size="small"
                    @click="del(scope.row)"
                >删除
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="roleRight_pagenation">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page.pageNo"
              :page-sizes="[PAGE_SIZE, 15, 20, 25]"
              :page-size="page.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.count"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 编辑弹框 -->
    <el-dialog
        title="新增/编辑版本公告"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="650px"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="100px"
        >
          <el-form-item
              class="item"
              label="状态："
              prop="verStatus"
          >
            <el-radio v-model="params.verStatus" :label="0">待发布</el-radio>
            <el-radio v-model="params.verStatus" :label="1">已发布</el-radio>
          </el-form-item>
          <el-row>
            <el-col :span="10">
              <el-form-item
                  label="版本号："
                  prop="verid"
              >
                <el-input
                    clearable
                    :disabled="clickType=='change'"
                    placeholder="请填写版本号"
                    v-model="params.verid"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item
                  label="发布时间："
                  prop="verTime"
              >
                <el-date-picker
                    v-model="params.verTime"
                    type="datetime"
                    placeholder="选择发布时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item
              class="item"
              label="标题："
              prop="title"
          >
            <el-input
                clearable
                style="width: 472px"
                placeholder="请填写标题"
                v-model="params.title"
            ></el-input>
          </el-form-item>
          <el-form-item class="item" label="内容：">
            <span class="clear_icon_items">*</span>
            <div style="width:470px">
              <richText :keyWord="'content'" :params="keyParments" v-if="flag"></richText>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
  </section>
</template>
<script>
import {PAGE_SIZE} from "@/config";
import richText from "../../components/richText";

export default {
  components: {
    richText
  },
  data() {
    return {
      flag: false,
      PAGE_SIZE,
      loading: false,
      // 分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      search: {},
      dialogVisible: false, //弹出框显示隐藏
      clickType: "", //弹窗类型
      params: {
        verStatus:0,
        content:''
      },
      keyParments:{
        content:''
      },//弹窗修改数据
      rules: {
        title: [
          {required: true, message: "请填写标题", trigger: "change"},
        ],
        verStatus: [
          {required: true, message: "请选择状态", trigger: "change"},
        ],
        verid: [
          {required: true, message: "请填写版本号", trigger: "change"},
        ],
        verTime: [
          {required: true, message: "选择发布时间", trigger: "change"},
        ],
        content: [
          {required: true, message: "请填写内容", trigger: "change"},
        ],
      }, //表单验证提示
      tableData: [], //列表

      searchShow: false,
      addShow: false,
      deleteShow: false,
      editShow: false,
      statusShow: true
    };
  },
  async created() {
    this.getRoleListTree();
    await this.getPermissionButtonList()
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
        this.params = {
          verStatus:0,
          content:''
        };
        this.keyParments = {
          content:''
        };
        this.flag = false
      }
    },
    search: {
      handler(val) {
      },
      deep: true,
    },
  },
  methods: {
    //权限处理
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'system:edition:query') {
            this.searchShow = true
          }
          if (item.code == 'system:edition:add') {
            this.addShow = true
          }
          if (item.code == "system:edition:delete") {
            this.deleteShow = true
          }
          if (item.code == "system:edition:edit") {
            this.editShow = true
          }
          if (item.code == "system:edition:status") {
            this.statusShow = false
          }
        })
      }
    },
    //筛选
    SearchPostList() {
      this.page.pageNo = 1
      this.getRoleListTree()
    },
    /**
     *  获取列表
     */
    async getRoleListTree(data, checked) {
      let http = `/sysver/list`;
      this.loading = true;
      const {data: resData} = await this.$get(http, {
        params: {...this.search, ...this.page},
      });
      this.loading = false;
      this.tableData = resData.data;
      this.page.count = resData.page.count;
    },
    // 弹窗
    async handleClick(type, row = {}) {
      this.clickType = type;
      if (type == "change") {
        this.loading = true;
        const {data: resData} = await this.$get('/sysver/info/'+row.sysverId);
        this.loading = false;
        // //修改  change
        this.params = {
          verStatus: resData.data.verStatus,
          verTime: new Date(resData.data.verTime),
          verid: resData.data.verid,
          title: resData.data.title,
          sysverId: resData.data.sysverId,
        };
        this.keyParments = {
          content: resData.data.content,
        };
        this.dialogVisible = true;
        this.flag = true
      } else {
        //添加
        this.params = {
          verStatus:0,
          content:''
        };
        this.keyParments = {
          content:''
        };
        this.flag = true
        this.dialogVisible = true;
      }
    },
    //窗口--提交 修改信息
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if(!this.keyParments.content){
          this.$message.error('请填写内容部分')
          return;
        }
        let passData = {
          content: this.keyParments.content,
          verid: this.params.verid,
          title: this.params.title,
          verStatus: this.params.verStatus,
          verTime: this.params.verTime,
        };
        if(this.params.sysverId){
          passData.sysverId = this.params.sysverId
        }
        if (!valid) return;
        this.$confirm("确认提交修改, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          if (this.clickType == "addNext") {
            const {data: resData} = await this.$post("/sysver/info", passData, {
              headers: {
                isLoading: true,
              },
            });
            if (resData.result != 200) return;
            this.getRoleListTree(); //重新获取数据
            this.dialogVisible = false; //弹窗隐藏
            this.params = {
              verStatus:0,
              content:''
            };
            this.keyParments = {
              content:''
            };
            this.flag = false
            this.$message.success("添加成功!");
          } else if (this.clickType == "change") {
            //修改岗位
            const {data: resData} = await this.$put(
                "/sysver/info",
                passData,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            this.getRoleListTree(); //重新获取数据
            this.dialogVisible = false; //弹窗隐藏
            this.params = {
              verStatus:0,
              content:''
            };
            this.keyParments = {
              content:''
            };
            this.flag = false
            this.$message.success("修改成功!");
          }
        });
      });
    },
    //删除
    del(row) {
      this.$confirm("一旦删除无法恢复, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `/sysver/info/${row.sysverId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getRoleListTree();
        this.$message.success("删除成功!");
      });
    },
    //分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getRoleListTree();
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getRoleListTree();
    },
  },
};
</script>

<style lang="scss" scoped>
.clear_icon_items {
  color: #F56C6C;
  position: absolute;
  left: -64px;
  top:0;
}
.role {
  display: flex;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;

  &Left {
    width: auto;
    padding-right: 15px;

    &_List {
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin-top: 20px;
    }
  }

  &Right {
    flex: 1;
    display: flex;
    overflow-x: hidden;
    flex-direction: column;
    border-left: 1px solid #ccc;
    padding-left: 15px;

    &_Top {
      display: flex;
      gap: 15px;

      .el-input {
        width: auto;
      }
    }

    &_Container {
      margin-top: 20px;
    }

    &_pagenation {
      margin: 40px auto;
    }

    ::v-deep .el-table th,
    ::v-deep .el-table td {
      text-align: center !important;
    }
  }
}
</style>
